import { render, staticRenderFns } from "./BreederLine.vue?vue&type=template&id=5966bbe5"
import script from "./BreederLine.vue?vue&type=script&lang=js"
export * from "./BreederLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports